/**
 * ContactOptions.js — "How would you like to connect?" options (kind "contact-options").
 *
 * Parity with old showContactOptions (script.js 2582): the bot question is a
 * separate text bubble; this renders the option buttons. Old stacks them
 * vertically as option buttons (no icon): Text a Live Person / Email Us / Call Us.
 *
 * Pure UI — clicking emits ws-contact-text / ws-contact-email / ws-contact-call;
 * the variant owns the follow-up messages.
 *
 * message.data: { email, phone, text_live_person }
 *   text_live_person (default true) — set false to hide the "Text a Live
 *   Person" option (e.g. Hestan's menu is Email Us + Call Us only).
 */

import { emit } from "../../../core/state.js";
import { getTheme } from "../../../core/configAccessors.js";

export default class ContactOptions {
  render(message) {
    const { email, text_live_person } = message?.data || {};
    const showText = text_live_person !== false;
    const botName = String(getTheme("bot_name", "Concierge") || "Concierge").trim();

    // Reuse the guided-prompt layout (.ws-prompts column + .ws-prompt-chip),
    // minus the icon — matches the old vertical option buttons.
    const wrap = document.createElement("div");
    wrap.className = "ws-prompts ws-contact-options";

    const make = (label, onClick, tag = "button") => {
      const el = document.createElement(tag);
      el.className = "ws-prompt-chip";
      if (tag === "button") el.type = "button";
      const span = document.createElement("span");
      span.className = "ws-prompt-label";
      span.textContent = label;
      el.appendChild(span);
      el.addEventListener("click", onClick);
      return el;
    };

    // Text a Live Person → RedChirp contact form (old showContactForm).
    // Hidden when the variant opts out (text_live_person:false) — e.g. Hestan,
    // whose old showContactOptions had only Email Us + Call Us.
    if (showText) {
      wrap.appendChild(make("Text a Live Person", () => emit("ws-contact-text")));
    }

    // Email Us → opens the mail client (mailto) + posts the email follow-up.
    // Subject from tenant-config theme.bot_name → "{bot_name} Request"
    // (old wineengine hard-coded "Grapevine Request!").
    const emailBtn = make("Email Us", () => emit("ws-contact-email"), "a");
    if (email) {
      const subject = encodeURIComponent(`${botName} Request`);
      emailBtn.href = `mailto:${email}?subject=${subject}`;
      emailBtn.target = "_blank";
      emailBtn.rel = "noopener noreferrer";
    }
    wrap.appendChild(emailBtn);

    // Call Us → posts the call follow-up.
    wrap.appendChild(make("Call Us", () => emit("ws-contact-call")));

    return wrap;
  }
}
